import { TinyColor } from '@ctrl/tinycolor';

function _toTinycolor(hslColor) {
    let args = {
        h: hslColor.h,
        s: hslColor.s,
        l: hslColor.l
    };

    if (hslColor.hasAlpha()) args.a = hslColor.a;
    return new TinyColor(args);
}

function _toHSLColor(tinycolor) {
    const {h, s, l, a} = tinycolor.toHsl();
    return new HSLColor(h, s, l, a);
}

/*
    Takes: percentages as numbers from 1.0 for all args
*/
export function HSLColor(h, s, l, a = 1.0) {
    this.h = h;
    this.s = s;
    this.l = l;
    this.a = a;
}

HSLColor.parseString = str => {
    if (!str) return null;
    const tc = new TinyColor(str);
    if (!tc.isValid) return null;
    const {h, s, l, a} = tc.toHsl();
    return new HSLColor(h, s, l, a);
};

HSLColor.prototype.hasAlpha = function() {
    return this.a !== 1 && this.a !== undefined && this.a !== null && typeof this.a === 'number';
};

HSLColor.prototype.toHexString = function() {
    return _toTinycolor(this)[this.hasAlpha() ? 'toHex8String' : 'toHexString']();
};

HSLColor.prototype.toHslString = function() {
    return _toTinycolor(this).toHslString();
};

HSLColor.prototype.copy = function() {
    return new HSLColor(this.h, this.s, this.l, this.a);
};

HSLColor.prototype.darken = function(amount = 10) {
    return _toHSLColor(_toTinycolor(this).darken(amount));
};

HSLColor.prototype.withHue = function(h) {
    let c = this.copy();
    c.h = h;
    return c;
};

HSLColor.prototype.withSaturation = function(s) {
    let c = this.copy();
    c.s = s;
    return c;
};

HSLColor.prototype.withLightness = function(l) {
    let c = this.copy();
    c.l = l;
    return c;
};

HSLColor.prototype.withAlpha = function(a) {
    let c = this.copy();
    c.a = a;
    return c;
};

